import * as actionsType from '../actions/actionsType';

const initialState = {
    loading: false,
    error: null,
    sent: false,
};

const mailReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionsType.MAIL_SEND_START:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case actionsType.MAIL_SEND_SUCCESS:
            return {
                loading: false,
                error: null,
                sent: true,
            };
        case actionsType.MAIL_SEND_FAIL:
            return {
                loading: false,
                error: action.error,
            }
        default:
            return {
                ...state,
            };
    }
}

export default mailReducer;